import React from "react";
import {
	Modal,
	ModalBody,
	ModalHeader,
} from "reactstrap";
import "./BaseModalV2.scss";
import Button from "../UIButton/UIButton";

export default function BaseModalV2({
	size = "md",
	visible = true,
	toggle,
	headerContent,
	children,
	headerClassName = "",
	bodyClassName = "",
    disableSubmit = false,
	disableCancel = false,
	onSubmit = (e) => {},
	onCancel = (e) => {},
	submitText = "Save Changes",
	cancelText = "Cancel",
	className = ""
}) {
	return (
		<Modal className={className} backdrop="static" size={size} isOpen={visible} toggle={toggle}>
			<ModalHeader
				className={`d-flex justify-content-between align-items-center location-modal-header p-3 ${headerClassName}`}
			>
				{headerContent}
			</ModalHeader>
			<ModalBody className={`${bodyClassName}`}>
				{children}
				<div className="gap-6 align-items-center text-center">
					<Button
						id="cancelButton"
						name="cancelButton"
						variant="info"
						disabled={disableCancel}
						onClick={onCancel}
					>
						{cancelText}
					</Button>

					<Button
						id="saveChangesButton"
						variant="submit"
						size="medium"
						name="saveChangesButton"
						disabled={disableSubmit}
						onClick={onSubmit}
					>
						{submitText}
					</Button>
				</div>
			</ModalBody>			
		</Modal>
	);
}
